import React, { Component } from 'react';
import contactCardUtils from './ContactCardUtils';
import ContactCardComponent from './ContactCardComponent';
import Page from '../../../lib/page';
import { trackLink } from '../../../lib/analytics-helper';
import { contactChannels } from '../../../common/commonConstants';
import {
  openCommunityExp,
  openMessageCenterExp,
  openResolutionCenterExp,
} from '../../../lib/globalHelper';

class ContactCardContainer extends Component {
  static renderContactOptionCard() {
    return contactCardUtils.map((contactDetails) => {
      const commonProps = {
        contactType: contactDetails.contactType,
        contactLabel: contactDetails.contactLabel,
        contactDescription: contactDetails.contactDescription,
        contactTarget: contactDetails.contactTarget,
        contactUrl: contactDetails.contactUrl,
        contactSize: contactDetails.contactSize,

      };
      return (contactDetails.contactDisplay)
        ? <ContactCardComponent {...commonProps} />
        : null;
    });
  }

  // Contact card option click function
  static clickHandler(e, contactOption) {
    e.preventDefault();
    if (contactOption.contactType) {
      // FPTI Click event when clicked on contact card
      trackLink({ id: Page.getFPTIPageId(), link: `smarthelp-hero-links|${contactOption.contactType}` });
    }
    switch (contactOption.contactType) {
      case contactChannels.RESOLUTION:
        return openResolutionCenterExp(contactOption.contactTarget);
      case contactChannels.COMMUNITY:
        return openCommunityExp(contactOption);
      case contactChannels.MESSAGE_CENTER:
        return openMessageCenterExp(contactOption.contactTarget);
      default:
        return <div />;
    }
  }

  // check for elmo treatment
  render() {
    return (
      <div className="contact-option-cards">
        {ContactCardContainer.renderContactOptionCard()}
      </div>
    );
  }
}

export default ContactCardContainer;
